/* eslint-disable jira/filename-case */
import React from 'react';
import Breadcrumb from '../../breadcrumb/component.tsx';
import type { BreadcrumbData } from '../../types.tsx';
import { createBoardUrl } from '../common/create-url/index.tsx';
import type { BoardBreadcrumbProps } from './types.tsx';

const BoardBreadcrumb = ({
	children = null,
	boardId,
	boardName,
	isSimplifiedProject = false,
	projectId = undefined,
}: BoardBreadcrumbProps): React.JSX.Element => {
	const breadcrumb: BreadcrumbData = {
		href: createBoardUrl(boardId),
		text: boardName,
		type: 'boardName',
		analyticsAttributes: {
			nextGenProject: isSimplifiedProject,
			projectConfig:
				isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic',
		},
		analyticsFields: {
			name: 'navigateToSubProject',
			containerId: projectId,
			containerType: 'project',
		},
	};

	return <Breadcrumb breadcrumb={breadcrumb}>{children}</Breadcrumb>;
};

export default BoardBreadcrumb;
